import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  actions: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: `${theme.spacing(2)}px`,
  },
  equalAllBtn: {
    backgroundColor: `${theme.color.blueLight} !important`,
    color: `${theme.color.white} !important`,
    marginLeft: `${theme.spacing(1)}px !important`,
  },
  buttons: {
    display: "flex",
    gap: theme.spacing(1),
  },
  topButton: {
    color: `${theme.color.black} !important`,
    "&.Mui-disabled": {
      color: `${theme.color.gray3} !important`,
      opacity: 0.5,
    },
  },
  suborders: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: `${theme.spacing(1)}px`,
    alignItems: "center",
  },
  title: {
    fontSize: "1.1rem",
    fontWeight: "600",
  },
  titleBlock: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  wrapper: {
    marginBottom: `${theme.spacing(2)}px`,
  },
  linkStyle: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: `${theme.color.black} !important`,
    marginLeft: theme.spacing(1),
    justifyContent: "flex-end",
    flexWrap: "wrap",
  },
  iconStyle: {
    verticalAlign: "middle",
    marginRight: theme.spacing(1),
    justifyContent: "center",
  },
  linkButton: {
    display: "flex inline-block",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    padding: theme.spacing(1),
    textDecoration: "underline",
    color: theme.color.blue,
    fontSize: "1rem",
    "&:hover": {
      textDecoration: "none",
    },
    "&:focus": {
      outline: "none",
    },
  },
  pipeStyle: {
    lineHeight: "1.1rem",
    verticalAlign: "middle",
    fontSize: "1.1rem",
    fontWeight: "600",
  },
}));
